module.exports = __webpack_public_path__ + "img/logoMensuel.46848daf.jpg";